import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { type PropType } from 'vue';

import usePromise from '@exchange/libs/composables/shared/src/lib/usePromise';
import { modalVariant, type ModalVariant } from '@exchange/libs/modals/src';


export default /*#__PURE__*/_defineComponent({
  __name: 'GeneralToSModal',
  props: {
  accept: { type: Function as PropType<() => Promise<void>>, required: true },
  variant: { type: String as PropType<ModalVariant>, default: modalVariant.dark },
},
  setup(__props) {

const props = __props;

const { loading: accepting, createPromise: acceptNow } = usePromise(props.accept);

return (_ctx: any,_cache: any) => {
  const _component_x_link_external = _resolveComponent("x-link-external")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_x_button = _resolveComponent("x-button")!
  const _component_x_modal = _resolveComponent("x-modal")!

  return (_openBlock(), _createBlock(_component_x_modal, {
    class: "general-tos-modal",
    "can-close": false,
    variant: __props.variant,
    title: _ctx.$t('ui.riskWarningModal.title')
  }, {
    content: _withCtx(() => [
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('ui.riskWarningModal.message1')), 1),
      _createVNode(_component_i18n_t, {
        keypath: "ui.riskWarningModal.message.text",
        tag: "p",
        scope: "global"
      }, {
        linkText: _withCtx(() => [
          _createVNode(_component_x_link_external, {
            href: _ctx.$t('ui.riskWarningModal.message.linkHref')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('ui.riskWarningModal.message.linkText')), 1)
            ]),
            _: 1
          }, 8, ["href"])
        ]),
        _: 1
      })
    ]),
    buttons: _withCtx(() => [
      _createVNode(_component_x_button, {
        variant: "primary",
        loading: _unref(accepting),
        disabled: _unref(accepting),
        onClick: _unref(acceptNow)
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('ui.riskWarningModal.agreeButton')), 1)
        ]),
        _: 1
      }, 8, ["loading", "disabled", "onClick"])
    ]),
    _: 1
  }, 8, ["variant", "title"]))
}
}

})